/**
 * This file is auto-generated from StartConsultationButton.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const startConsultation: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Start consultation';
        case 'pl':
            return 'Rozpocznij konsultację';
    }
};
